import React from "react";
import { styled } from "@mui/material";
import IconButton from "../../IconButton";

const Wrapper = styled("div")<{ width?: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: ${(props) => props.width || "auto"};
  height: 100%;
`;

type FloatingActionBarCloseButtonProps = {
  tooltipProps?: React.ComponentProps<typeof IconButton>["tooltipProps"];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  width?: string;
};

export default function FloatingActionBarCloseButton({
  tooltipProps = {},
  onClick,
  width,
}: FloatingActionBarCloseButtonProps) {
  return (
    <Wrapper width={width}>
      <IconButton
        tooltipProps={{
          placement: "top",
          type: "light",
          ...tooltipProps,
        }}
        onClick={onClick}
        name="close"
        shape="round"
        size="medium"
        type="secondary"
        variant="transparent"
      />
    </Wrapper>
  );
}
